<template>
  <div>
    <div class="p-3">
      <div class="breadcrumb-area pos-relative w-100">
        <h1>Cập nhật phiếu thu đối tác</h1>
        <div class="btn-group float-right">
          <button
            type="button"
            class="font-medium btn btn-outline-secondary"
            @click="$router.push(`/agent-receipt`)"
          >
            <i class="bx bx-arrow-back"></i> Quay lại
          </button>
          <button class="btn font-medium btn-primary" @click="saveData">
            <i class="bx bx-save"></i><span>&nbsp;</span>Lưu
          </button>
        </div>
      </div>
      <div class="p-10 pt-15 b-t-1-869fb229">
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-detail card p-4">
              <!-- <div class="form-group form-row">
                <label for="amount" class="col-sm-3 col-form-label">
                  Số tiền <span class="text-danger">*</span>
                </label>
                <div class="col-sm-9">
                  <input id="amount" v-model="formData.amount" type="text" class="form-control"
                    :class="{ 'is-invalid': validationErrors.amount }" @input="validateAmount" @keypress="numberOnly" />
                  <div v-if="validationErrors.amount" class="invalid-feedback">
                    {{ validationErrors.amount }}
                  </div>
                </div>
              </div> -->

              <div class="form-group form-row">
                <label for="appendix-code" class="col-sm-3 col-form-label">
                  Mã phụ lục <span class="text-danger">*</span>
                </label>
                <div class="col-sm-9">
                  <input
                    id="appendix-code"
                    v-model="formData.appendixCode"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': validationErrors.appendixCode }"
                  />
                  <div v-if="validationErrors.appendixCode" class="invalid-feedback">
                    {{ validationErrors.appendixCode }}
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="receipt-date" class="col-sm-3 col-form-label"> Ngày thu tiền </label>
                <div class="col-sm-9">
                  <div class="date-picker-wrapper position-relative">
                    <input
                      id="receipt-date"
                      v-model="formData.receiptDate"
                      type="date"
                      class="form-control"
                      :class="{ 'is-invalid': validationErrors.receiptDate }"
                      @click="openDatePicker"
                      ref="dateInput"
                    />
                    <i
                      class="bx bx-calendar position-absolute"
                      style="right: 10px; top: 10px; cursor: pointer"
                      @click="openDatePicker"
                    ></i>
                    <div v-if="validationErrors.receiptDate" class="invalid-feedback">
                      {{ validationErrors.receiptDate }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="transaction-code" class="col-sm-3 col-form-label"> Mã giao dịch </label>
                <div class="col-sm-9">
                  <input
                    id="transaction-code"
                    v-model="formData.transactionCode"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': validationErrors.transactionCode }"
                  />
                  <div v-if="validationErrors.transactionCode" class="invalid-feedback">
                    {{ validationErrors.transactionCode }}
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="description" class="col-sm-3 col-form-label"> Ghi chú </label>
                <div class="col-sm-9">
                  <textarea
                    id="description"
                    v-model="formData.description"
                    class="form-control"
                    :class="{ 'is-invalid': validationErrors.description }"
                    rows="3"
                  ></textarea>
                  <div v-if="validationErrors.description" class="invalid-feedback">
                    {{ validationErrors.description }}
                  </div>
                </div>
              </div>

              <!-- TEMPLATE - Thay thế phần đơn giá hiện tại -->
              <div class="form-group form-row my-4">
                <label for="unit-price" class="col-sm-3 col-form-label"> Đơn giá </label>
                <div class="col-sm-9">
                  <div
                    v-for="(item, index) in detail.products"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      margin-bottom: 10px;
                    "
                    :key="index"
                  >
                    <p style="margin: 0; min-width: 150px">{{ item?.name }}</p>
                    <p style="margin: 0; min-width: 80px; text-align: center">
                      Số lượng: {{ item?.quantity }}
                    </p>
                    <div style="min-width: 100px">
                      <input
                        :id="`unit-price-${index}`"
                        v-model="item.unitPrice"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': validationErrors[`unitPrice_${index}`] }"
                        @input="validateUnitPrice(index)"
                        @keypress="numberOnly"
                        placeholder="Nhập đơn giá (không bắt buộc)"
                      />
                      <div v-if="validationErrors[`unitPrice_${index}`]" class="invalid-feedback">
                        {{ validationErrors[`unitPrice_${index}`] }}
                      </div>
                    </div>
                  </div>

                  <!-- Hiển thị tổng -->
                  <div class="total-section mt-3 pt-3 border-top">
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        font-weight: bold;
                        font-size: 13px;
                      "
                    >
                      <span>Tổng cộng:</span>
                      <span class="text-primary">{{ formatCurrency(calculateTotal()) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="appendix-files" class="col-sm-3 col-form-label"> File phụ lục </label>
                <div class="col-sm-9">
                  <div class="custom-file mb-2">
                    <input
                      id="appendix-files"
                      type="file"
                      class="custom-file-input"
                      @change="handleAppendixFilesUpload"
                      accept=".pdf"
                      multiple
                    />
                    <label class="custom-file-label" for="appendix-files">
                      {{ appendixFileLabel }}
                    </label>
                  </div>

                  <!-- Danh sách file đã chọn -->
                  <div
                    v-if="appendixFiles.length > 0"
                    class="appendix-files-section mb-3 bg-light-subtle rounded-3"
                  >
                    <h6 class="file-section-title fw-bold mb-2" style="font-size: 12px">
                      Files phụ lục
                    </h6>

                    <div class="upload-files-container">
                      <div
                        v-for="(file, index) in appendixFiles"
                        :key="index"
                        class="file-item mb-2 p-3 border border-dashed bg-white rounded-3 shadow-sm d-flex align-items-center justify-content-between"
                      >
                        <div class="d-flex align-items-center flex-grow-1">
                          <i
                            class="bx bxs-file text-primary file-icon me-3"
                            style="font-size: 32px"
                          ></i>

                          <div class="file-info overflow-hidden">
                            <div class="file-name text-truncate fw-medium">{{ file.name }}</div>
                            <div
                              class="file-status small mt-1"
                              :class="{
                                'text-primary': file.status === 'uploading',
                                'text-success':
                                  file.status === 'done' || file.status === 'uploaded',
                                'text-muted': file.status === 'pending',
                              }"
                            >
                              <span
                                v-if="file.status === 'uploading'"
                                class="d-flex align-items-center"
                              >
                                <i class="bx bx-loader-alt bx-spin me-1"></i>
                                Đang tải lên...
                              </span>
                              <span
                                v-else-if="file.status === 'done'"
                                class="d-flex align-items-center"
                              >
                                <i class="bx bx-check-circle me-1"></i>
                                Đã tải lên
                              </span>
                              <span
                                v-else-if="file.status === 'uploaded'"
                                class="d-flex align-items-center"
                              >
                                <i class="bx bx-check-circle me-1"></i>
                                Đã tải lên trước đó
                              </span>
                              <span v-else class="text-muted"> Chờ tải lên </span>
                            </div>
                          </div>
                        </div>

                        <div class="file-actions ms-2 d-flex align-items-center">
                          <!-- Nút xem trước chỉ hiển thị với file đã upload -->
                          <a
                            v-if="file.status === 'uploaded' || file.status === 'done'"
                            :href="file.url"
                            target="_blank"
                            class="btn btn-sm btn-icon rounded-circle me-2"
                            title="Xem file"
                          >
                            <i class="bx bx-link-external text-primary"></i>
                          </a>

                          <button
                            type="button"
                            class="btn btn-sm btn-icon rounded-circle"
                            @click="removeAppendixFile(index)"
                            title="Xóa file"
                          >
                            <i class="bx bx-trash text-danger"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="upload-images" class="col-sm-3 col-form-label">
                  Ảnh chuyển khoản
                </label>
                <div class="col-sm-9">
                  <div class="custom-file mb-2">
                    <input
                      id="upload-images"
                      type="file"
                      class="custom-file-input"
                      @change="handleImagesUpload"
                      accept="image/*"
                      multiple
                    />
                    <label class="custom-file-label" for="upload-images">
                      {{ imageFileLabel }}
                    </label>
                  </div>

                  <!-- Danh sách ảnh đã chọn -->
                  <div v-if="uploadImages.length > 0" class="upload-images-section mb-3">
                    <h6 class="file-section-title fw-bold mb-1" style="font-size: 12px">
                      Ảnh chuyển khoản
                    </h6>

                    <div class="image-gallery d-flex flex-wrap">
                      <div
                        v-for="(image, index) in uploadImages"
                        :key="index"
                        class="image-item position-relative m-2"
                        style="width: 100px; height: 100px"
                      >
                        <img
                          :src="image.preview"
                          alt="preview"
                          class="img-thumbnail"
                          style="width: 100%; height: 100%; object-fit: cover"
                        />

                        <button
                          type="button"
                          class="btn btn-sm btn-danger position-absolute"
                          style="
                            top: 5px;
                            right: 5px;
                            width: 24px;
                            height: 24px;
                            padding: 0;
                            border-radius: 50%;
                          "
                          @click="removeImage(index)"
                          title="Xóa ảnh"
                        >
                          <i class="bx bx-x"></i>
                        </button>

                        <!-- Hiển thị nút xem ảnh gốc nếu đã upload -->
                        <a
                          v-if="image.status === 'uploaded' || image.status === 'done'"
                          :href="image.url"
                          target="_blank"
                          class="btn btn-sm btn-primary position-absolute"
                          style="
                            bottom: 5px;
                            right: 5px;
                            width: 24px;
                            height: 24px;
                            padding: 0;
                            border-radius: 50%;
                          "
                          title="Xem ảnh gốc"
                        >
                          <i class="bx bx-link-external"></i>
                        </a>

                        <div
                          class="image-status small text-center mt-1"
                          :class="{
                            'text-primary': image.status === 'uploading',
                            'text-success': image.status === 'done' || image.status === 'uploaded',
                            'text-muted': image.status === 'pending',
                          }"
                        >
                          <span v-if="image.status === 'uploading'">
                            <i class="bx bx-loader-alt bx-spin"></i>
                          </span>
                          <span v-else-if="image.status === 'done'">
                            <i class="bx bx-check-circle"></i> Mới
                          </span>
                          <span v-else-if="image.status === 'uploaded'">
                            <i class="bx bx-check-circle"></i> Đã tải
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-notification" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img
          :src="
            isSuccess
              ? require('@/assets/img/noti-success2.svg')
              : require('@/assets/img/noti-unsuccess2.svg')
          "
          :alt="isSuccess ? 'icon-success' : 'icon-error'"
        />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer>
        <b-button size="sm" variant="light" @click="handleCloseModal"> Đóng </b-button>
      </template>
    </b-modal>

    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import { DeviceService } from '@/services/device.service'

  import { CommonService } from '@/services/common.service'

  export default {
    data() {
      return {
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: false,
        id: this.$route.params.id,
        Config,
        listDevice: [],
        formData: {
          agencyCode: '',
          amount: null,
          appendixCode: '',
          receiptDate: '', // Mặc định là ngày hiện tại
          transactionCode: '',
          description: '',
          devices: [],
          uploadImgs: [],
          source: 'NEXT_AGENT',
          purchaseOrderCode: '',
        },
        appendixFiles: [], // Mảng các file phụ lục cần upload
        uploadImages: [], // Mảng các ảnh cần upload
        appendixFileLabel: '(Chọn nhiều file PDF)',
        imageFileLabel: '(Chọn nhiều ảnh)',
        validationErrors: {
          agencyCode: '',
          // amount: '',
          appendixCode: '',
          receiptDate: '',
          transactionCode: '',
          description: '',
          purchaseOrderCode: '',
        },
        notiModal: false,
        msgNoti: '',
        isSuccess: true,
        detail: {},
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    created() {
      this.fetchData()
    },

    methods: {
      validateUnitPrice(index) {
        const item = this.detail.devices[index]
        const unitPriceValue = item.unitPrice
        const fieldKey = `unitPrice_${index}`

        // Xóa thông báo lỗi trước đó
        this.$set(this.validationErrors, fieldKey, '')

        // Nếu không nhập gì thì không validate (vì không bắt buộc)
        if (!unitPriceValue || unitPriceValue.toString().trim() === '') {
          item.unitPrice = null
          return
        }

        // Chuyển đổi thành số
        const numericValue = parseFloat(unitPriceValue)

        // Validate số hợp lệ
        if (isNaN(numericValue)) {
          this.$set(this.validationErrors, fieldKey, 'Vui lòng nhập số hợp lệ')
          item.unitPrice = null
        } else if (numericValue < 0) {
          this.$set(this.validationErrors, fieldKey, 'Đơn giá không được âm')
          item.unitPrice = null
        } else {
          // Hợp lệ - lưu giá trị số
          item.unitPrice = numericValue
        }
      },

      calculateTotal() {
        if (!this.detail.products || this.detail.products.length === 0) {
          return 0
        }

        return this.detail.products.reduce((total, item) => {
          const unitPrice = parseFloat(item.unitPrice) || 0
          const quantity = parseFloat(item.quantity) || 0
          return total + unitPrice * quantity
        }, 0)
      },

      formatCurrency(amount) {
        return new Intl.NumberFormat('vi-VN', {
          style: 'currency',
          currency: 'VND',
        }).format(amount)
      },

      openDatePicker() {
        // Khi người dùng click vào input hoặc biểu tượng lịch
        // Mở bộ chọn ngày bằng cách gọi click() trên input type="date"
        this.$refs.dateInput.showPicker
          ? this.$refs.dateInput.showPicker()
          : this.legacyDatePickerFocus()
      },

      legacyDatePickerFocus() {
        // Phương pháp dự phòng cho các trình duyệt không hỗ trợ showPicker()
        this.$refs.dateInput.focus()

        // Thêm sự kiện click vào input để trigger bộ chọn ngày
        // Tạo một sự kiện mouse event giả
        const clickEvent = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true,
        })

        // Gửi sự kiện click tới input
        this.$refs.dateInput.dispatchEvent(clickEvent)
      },

      numberOnly(e) {
        // Chỉ cho phép nhập số và dấu chấm cho số thập phân
        const charCode = e.which ? e.which : e.keyCode
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46 // dấu chấm (.) cho số thập phân
        ) {
          e.preventDefault()
        }
      },
      validateAmount() {
        // Xử lý khi người dùng nhập giá trị
        const amountValue = this.formData.amount

        // Chuyển đổi giá trị nhập vào thành số
        const numericValue = parseFloat(amountValue)

        // Xóa thông báo lỗi nếu đã có
        this.validationErrors.amount = ''

        // Nếu giá trị không phải số hợp lệ hoặc âm
        if (isNaN(numericValue)) {
          this.formData.amount = null
          this.validationErrors.amount = 'Vui lòng nhập số hợp lệ'
        } else if (numericValue < 0) {
          this.formData.amount = null
          this.validationErrors.amount = 'Số tiền không được âm'
        } else {
          // Nếu hợp lệ, lưu giá trị đã được chuyển đổi thành số
          this.formData.amount = numericValue
        }
      },
      async fetchData() {
        try {
          this.showLoading = true

          const data = await DeviceService.detailTransferAgencyNew(this.id)

          if (data.success || data.code === 1000) {
            this.detail = data.data || {}
            this.formData.amount = this.detail.amount
            this.formData.appendixCode = this.detail.appendixCode

            // Chuyển đổi ngày từ timestamp sang định dạng YYYY-MM-DD
            if (this.detail.receiptDate) {
              const date = new Date(this.detail.receiptDate)
              this.formData.receiptDate = date.toISOString().substr(0, 10)
            }

            this.formData.transactionCode = this.detail.transactionCode
            this.formData.description = this.detail.description
            this.formData.purchaseOrderCode = this.detail.purchaseOrderCode
            this.listDevice = this.detail.devices

            this.detail.products = data.data.products.map(item => {
              return {
                name: item.name,
                amount: item.amount,
                unitPrice: item.price,
                quantity: item.quantity,
              }
            })

            // Nhóm các thiết bị cùng tên và tính tổng số lượng
            // if (this.detail.devices && this.detail.devices.length > 0) {
            //   const groupedDevices = {};

            //   // Nhóm thiết bị theo tên
            //   this.detail.devices.forEach(device => {
            //     const deviceName = device.name || device.categoryName || '';
            //     if (groupedDevices[deviceName]) {
            //       // Nếu đã tồn tại, tăng số lượng
            //       groupedDevices[deviceName].quantity += 1;
            //     } else {
            //       // Nếu chưa tồn tại, tạo mới
            //       groupedDevices[deviceName] = {
            //         name: deviceName,
            //         quantity: 1,
            //         unitPrice: null // Khởi tạo unitPrice
            //       };
            //     }
            //   });

            //   // Chuyển từ object thành array
            //   this.detail.devices = Object.values(groupedDevices);

            //   // Khởi tạo unitPrice cho mỗi device (sử dụng cách an toàn)
            //   this.detail.devices.forEach(device => {
            //     if (!Object.prototype.hasOwnProperty.call(device, 'unitPrice')) {
            //       this.$set(device, 'unitPrice', null);
            //     }
            //   });
            // }

            // Xử lý uploadImages từ API
            if (this.detail.uploadImgs && this.detail.uploadImgs.length > 0) {
              this.detail.uploadImgs.forEach(img => {
                this.uploadImages.push({
                  file: null, // Không có file object vì đã upload
                  name: this.getFileNameFromUrl(img),
                  status: 'uploaded', // Đánh dấu là đã upload
                  preview: img, // URL từ API
                  url: img, // Lưu lại URL để sử dụng khi submit
                })
              })

              this.imageFileLabel = `${this.uploadImages.length} ảnh đã được tải`
            }

            // Xử lý appendixFiles từ API
            if (this.detail.appendixFiles && this.detail.appendixFiles.length > 0) {
              this.detail.appendixFiles.forEach(file => {
                this.appendixFiles.push({
                  file: null, // Không có file object vì đã upload
                  name: this.getFileNameFromUrl(file),
                  status: 'uploaded', // Đánh dấu là đã upload
                  url: file, // Lưu lại URL để sử dụng khi submit
                })
              })

              this.appendixFileLabel = `${this.appendixFiles.length} file đã được tải`
            }
          }
        } catch (error) {
          console.error(error)
        } finally {
          this.showLoading = false
        }
      },

      // Thêm phương thức để lấy tên file từ URL
      getFileNameFromUrl(url) {
        if (!url) return 'Tệp không xác định'
        // Lấy phần cuối cùng của URL sau dấu '/'
        const parts = url.split('/')
        let fileName = parts[parts.length - 1]

        // Loại bỏ các tham số truy vấn nếu có
        if (fileName.includes('?')) {
          fileName = fileName.split('?')[0]
        }

        // Giải mã URL encoding nếu cần
        try {
          fileName = decodeURIComponent(fileName)
        } catch (e) {
          console.error('Lỗi giải mã tên file:', e)
        }

        return fileName
      },

      handleAppendixFilesUpload(event) {
        const files = event.target.files
        if (files && files.length > 0) {
          // Thêm files vào mảng appendixFiles
          for (let i = 0; i < files.length; i++) {
            this.appendixFiles.push({
              file: files[i],
              name: files[i].name,
              status: 'pending', // File mới thêm có trạng thái 'pending'
            })
          }

          // Cập nhật label
          this.appendixFileLabel = `${this.appendixFiles.length} file được chọn`
        } else {
          this.appendixFileLabel = '(Chọn nhiều file PDF)'
        }

        // Reset input để có thể chọn lại file đã chọn trước đó
        event.target.value = ''
      },

      handleImagesUpload(event) {
        const files = event.target.files
        if (files && files.length > 0) {
          // Thêm files vào mảng uploadImages
          for (let i = 0; i < files.length; i++) {
            const file = files[i]
            const reader = new FileReader()

            reader.onload = e => {
              this.uploadImages.push({
                file: file,
                name: file.name,
                status: 'pending', // File mới thêm có trạng thái 'pending'
                preview: e.target.result,
              })
            }

            reader.readAsDataURL(file)
          }

          // Cập nhật label
          this.imageFileLabel = `${files.length} ảnh được chọn`
        } else {
          this.imageFileLabel = '(Chọn nhiều ảnh)'
        }

        // Reset input để có thể chọn lại file đã chọn trước đó
        event.target.value = ''
      },

      removeAppendixFile(index) {
        this.appendixFiles.splice(index, 1)
        this.appendixFileLabel =
          this.appendixFiles.length > 0
            ? `${this.appendixFiles.length} file đã được chọn`
            : '(Chọn nhiều file PDF)'
      },
      removeImage(index) {
        this.uploadImages.splice(index, 1)
        this.imageFileLabel =
          this.uploadImages.length > 0
            ? `${this.uploadImages.length} ảnh đã được chọn`
            : '(Chọn nhiều ảnh)'
      },
      // Upload file lên S3
      async uploadFileToS3(fileItem) {
        try {
          const formData = new FormData()
          formData.append('files', fileItem.file)
          formData.append('folderName', 'NextCrm')

          const response = await CommonService.uploadFile(formData)
          if (response && response.data && response.data.length > 0) {
            fileItem.status = 'done'
            fileItem.url = response.data[0] // Lưu URL sau khi upload
            return response.data[0]
          }
          return null
        } catch (error) {
          console.error('Upload file error:', error)
          return null
        }
      },
      async uploadImageToS3(fileItem) {
        try {
          const formData = new FormData()
          formData.append('files', fileItem.file)
          formData.append('folderName', 'NextCrm')

          const response = await CommonService.uploadImg(formData)
          if (response && response.data && response.data.length > 0) {
            fileItem.status = 'done'
            fileItem.url = response.data[0] // Lưu URL sau khi upload
            return response.data[0]
          }
          return null
        } catch (error) {
          console.error('Upload file error:', error)
          return null
        }
      },

      // Upload tất cả các file phụ lục
      async uploadAllAppendixFiles() {
        const uploadedFiles = []

        // Đầu tiên, thêm các file đã upload trước đó
        for (let i = 0; i < this.appendixFiles.length; i++) {
          if (this.appendixFiles[i].status === 'uploaded') {
            // Nếu file đã được upload trước đó, chỉ thêm URL
            uploadedFiles.push(this.appendixFiles[i].url)
          } else if (this.appendixFiles[i].status === 'pending') {
            // Chỉ upload các file có trạng thái 'pending'
            this.appendixFiles[i].status = 'uploading'
            const result = await this.uploadFileToS3(this.appendixFiles[i])
            if (result) {
              uploadedFiles.push(result)
            } else {
              this.showErrorModal(`Không thể tải lên file: ${this.appendixFiles[i].name}`)
              return null
            }
          } else if (this.appendixFiles[i].status === 'done') {
            // Nếu file đã được upload trong session hiện tại
            uploadedFiles.push(this.appendixFiles[i].url)
          }
        }

        return uploadedFiles
      },
      // Upload tất cả các ảnh
      async uploadAllImages() {
        const uploadedImages = []

        // Tương tự như uploadAllAppendixFiles
        for (let i = 0; i < this.uploadImages.length; i++) {
          if (this.uploadImages[i].status === 'uploaded') {
            // Nếu ảnh đã được upload trước đó
            uploadedImages.push(this.uploadImages[i].url)
          } else if (this.uploadImages[i].status === 'pending') {
            // Chỉ upload các ảnh có trạng thái 'pending'
            this.uploadImages[i].status = 'uploading'
            const result = await this.uploadImageToS3(this.uploadImages[i])
            if (result) {
              uploadedImages.push(result)
            } else {
              this.showErrorModal(`Không thể tải lên ảnh: ${this.uploadImages[i].name}`)
              return null
            }
          } else if (this.uploadImages[i].status === 'done') {
            // Nếu ảnh đã được upload trong session hiện tại
            uploadedImages.push(this.uploadImages[i].url)
          }
        }

        return uploadedImages
      },

      validateForm() {
        let isValid = true

        // Reset all validation errors
        Object.keys(this.validationErrors).forEach(key => {
          this.validationErrors[key] = ''
        })

        // Kiểm tra amount
        // if (!this.formData.amount) {
        //   this.validationErrors.amount = 'Vui lòng nhập số tiền';
        //   isValid = false;
        // } else if (this.formData.amount <= 0) {
        //   this.validationErrors.amount = 'Vui lòng nhập số tiền lớn hơn 0';
        //   isValid = false;
        // }

        if (!this.formData.appendixCode.trim()) {
          this.validationErrors.appendixCode = 'Vui lòng nhập mã phụ lục'
          isValid = false
        }

        return isValid
      },
      async saveData() {
        // Validate form
        if (!this.validateForm()) {
          this.showErrorModal('Vui lòng điền đầy đủ thông tin')
          return
        }

        try {
          this.loading = true

          // Upload tất cả file phụ lục nếu có
          let uploadedFiles = []
          if (this.appendixFiles.length > 0) {
            const filesResult = await this.uploadAllAppendixFiles()
            if (!filesResult) {
              this.loading = false
              return
            }
            uploadedFiles = filesResult
          }

          // Upload tất cả ảnh nếu có
          let uploadedImages = []
          if (this.uploadImages.length > 0) {
            const imagesResult = await this.uploadAllImages()
            if (!imagesResult) {
              this.loading = false
              return
            }
            uploadedImages = imagesResult
          }

          // Chuẩn bị dữ liệu products từ orderDetail
          const products = this.detail.products
            ? this.detail.products.map(item => {
                const unitPrice = parseFloat(item.unitPrice) || 0
                const quantity = parseFloat(item.quantity) || 0
                const amount = unitPrice * quantity // Tổng của 1 loại sản phẩm

                return {
                  name: item.categoryName || item.name || '',
                  amount: amount, // Tổng tiền của loại sản phẩm này
                  price: unitPrice,
                  quantity: quantity,
                }
              })
            : []

          const totalAmount = products.reduce((sum, product) => sum + product.amount, 0)

          // Tạo payload theo cấu trúc API yêu cầu
          const payload = {
            id: this.id,
            amount: totalAmount,
            // amount: this.formData.amount,
            appendixCode: this.formData.appendixCode,
            transactionCode: this.formData.transactionCode,
            description: this.formData.description,
            devices: this.listDevice || [], // Chưa rõ cấu trúc, nên để mảng rỗng
            uploadImgs: uploadedImages,
            appendixFiles: uploadedFiles,
            purchaseOrderCode: this.formData.purchaseOrderCode,
            products: products,
          }

          // Chuyển đổi receiptDate từ string sang timestamp nếu cần
          if (this.formData.receiptDate) {
            const date = new Date(this.formData.receiptDate)
            payload.receiptDate = date.getTime()
          }

          // Gọi API tạo phiếu thu
          const response = await DeviceService.updateTransferAgencys(payload)

          if (response && response.code === 1000) {
            this.showSuccessModal('Tạo phiếu thu thành công')

            // Reset form
            this.formData = {
              agencyCode: '',
              amount: null,
              appendixCode: '',
              receiptDate: new Date().toISOString().substr(0, 10),
              transactionCode: '',
              description: '',
              devices: [],
              uploadImgs: [],
              source: 'NEXT_AGENT',
              purchaseOrderCode: '',
            }

            // Xóa mảng file và ảnh đã upload
            this.appendixFiles = []
            this.uploadImages = []
            this.appendixFileLabel = '(Chọn nhiều file)'
            this.imageFileLabel = '(Chọn nhiều ảnh)'
          } else {
            this.showErrorModal(response?.message || 'Có lỗi xảy ra, vui lòng thử lại sau')
          }
        } catch (error) {
          this.showErrorModal(error?.message || 'Có lỗi xảy ra, vui lòng thử lại sau')
        } finally {
          this.loading = false
        }
      },

      showSuccessModal(message) {
        this.isSuccess = true
        this.msgNoti = message
        this.notiModal = true
      },

      showErrorModal(message) {
        this.isSuccess = false
        this.msgNoti = message
        this.notiModal = true
      },

      handleCloseModal() {
        this.notiModal = false
        // Nếu thành công, quay về trang danh sách
        if (this.isSuccess) {
          this.$router.push('/agent-receipt')
        }
      },
    },
  }
</script>

<style scoped>
  .card {
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  }

  .breadcrumb-area {
    margin-bottom: 20px;
  }

  .breadcrumb-area h1 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 0;
  }

  .btn-group .btn {
    margin-left: 5px;
  }

  .custom-file-label::after {
    content: 'Chọn file';
  }

  .text-danger {
    color: #dc3545 !important;
  }

  .invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
  }

  .is-invalid {
    border-color: #dc3545;
  }

  .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
  }

  .btn-danger {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
  }

  .border-dashed {
    border-style: dashed !important;
  }

  input[type='date']::-webkit-calendar-picker-indicator {
    opacity: 0;
    /* Ẩn icon mặc định nhưng vẫn giữ tính năng */
    width: 100%;
    /* Mở rộng vùng click */
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
  }

  /* Style cho icon lịch tùy chỉnh */
  .bx-calendar {
    color: #666;
    font-size: 1.2rem;
    transition: color 0.2s;
  }

  .bx-calendar:hover {
    color: #007bff;
  }

  /* Sửa lại icon để hiển thị đúng */
  .bx {
    font-family: 'boxicons' !important;
    font-weight: normal;
    font-style: normal;
    display: inline-block;
  }
</style>
